import React, { useState } from "react"
import { Eye, EyeOff } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { login } from "../../actions/authActions"
import backgroundImage from "../../assets/LoginImage.jpg"

function LoginForm() {
    const [serviceNumber, setServiceNumber] = useState("");
    const [password, setPassword] = useState("");
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loading, error } = useSelector(
        (state) => state.auth
    );

    const handleSubmit = async (e) => {
        e.preventDefault();

        const user = await dispatch(
            login(serviceNumber, password)
        );

        if (!user) return;

        if (user.Role === "A") {
            navigate("/admin");
        }

        if (user.Role === "U") {
            navigate("/user");
        }
    }

    return (
        <>
            {/* LEFT */}        
            <div className="flex w-full lg:w-1/2 items-center justify-center px-6 md:px-12">
                <form
                    onSubmit={handleSubmit}
                    className="w-full max-w-md"
                >
                    <h1 className="mb-2 text-3xl lg:text-4xl font-bold text-center md:text-left">
                        <span className="text-deepNavy">LIVE</span>
                        <span className="text-signalOrange">GRID</span>
                    </h1>

                    <p className="mb-5 md:mb-10 text-slate-500 text-xs md:text-base text-center md:text-left">Real-Time Generator & Power Distribution Monitoring</p>

                    {error && (
                        <div className="mb-6 rounded-xl bg-red-100 px-3 py-2 md:px-4 md:py-3 text-sm md:text-base text-red-700">
                            {error}
                        </div>
                    )}

                    <div className="mb-3 md:mb-5">
                        <label className="mb-2 block text-sm font-medium text-slate-700">Service Number</label>
                        <input 
                            type="text"
                            value={serviceNumber}
                            onChange={(e) => setServiceNumber(e.target.value)}
                            className="w-full rounded-2xl border border-slate-200 p-3 md:px-5 md:py-4 text-sm md:text-base outline-none transition focus:border-blue-500"
                            placeholder="Enter Service Number"
                        />
                    </div>

                    <div className="mb-5 md:mb-8">
                        <label className="mb-2 block text-sm font-medium text-slate-700">Password</label>
                        <div className="relative">
                            <input 
                                type={isPasswordVisible ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full rounded-2xl border border-slate-200 p-3 md:px-5 md:py-4 text-sm md:text-base outline-none transition focus:border-blue-500"
                                placeholder="Enter password"
                            />
                            <button
                                type="button"
                                onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                                className="absolute right-4 top-1/2 -translate-y-1/2"
                            >
                                {isPasswordVisible ? (
                                    <Eye size={18} />
                                ) : (
                                    <EyeOff size={18} />
                                )}
                            </button>
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="h-12 md:h-14 w-full rounded-2xl bg-deepNavy font-semibold text-white transition hover:bg-navy"
                    >
                        {loading ? "Authenticating..." : "Sign In"}
                    </button>
                </form>
            </div>

            {/* RIGHT PANEL */}
            <div
                className="hidden lg:flex lg:w-1/2 rounded-l-[80px] overflow-hidden bg-cover bg-center relative"
                style={{
                    backgroundImage: `url(${backgroundImage})`
                }}
            >
                {/* Overlay */}
                <div className="absolute inset-0 bg-deepNavy/80" />

                {/* Content */}
                <div className="relative z-10 flex flex-col justify-between h-full px-16 py-16 text-white">
                    <div>
                        <div className="mb-6 inline-flex rounded-full border border-white/20 px-4 py-2 text-sm">
                            Power Monitoring System
                        </div>

                        <h2 className="text-5xl font-bold max-w-sm">
                            Monitor Every Watt.
                        </h2>

                        <p className="mt-6 max-w-md text-blue-100">
                            Real-time visibility into generators, power distribution and
                            operational health across Dockyard infrastructure.
                        </p>
                    </div>

                    <div>
                        <div className="text-sm uppercase tracking-[4px] text-blue-200">
                            Colombo Dockyard PLC
                        </div>

                        <div className="mt-2 text-2xl font-semibold">
                            LIVEGRID
                        </div>

                        <div className="mt-3">
                            <div className="mt-2 text-sm">
                                <h5>Copyrights &copy; Dockyard Total Solutions (PVT) LTD</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginForm;